// Flat row shape from GET /assessment-admin-panel/ (tpn-admin: AssessmentAdminPanelSerializer).
// One row per AssessmentSurvey; nullable fields reflect that an AssessmentSurvey may not yet
// have a related Assessment/Workflow.
export interface AssessmentAdminPanelRow {
  id: number;
  survey: number;
  status: string;
  submittedDate: string | null;
  updatedAt: string;
  adminReviewer: number | null;
  companyName: string | null;
  assessorName: string | null;
  assessorCompanyName: string | null;
  assessorLevel: string | null;
  siteAppName: string | null;
  dateAccepted: string | null;
  assessmentId: number | null;
  assessmentStatus: string | null;
  workflowId: number | null;
  workflowStatus: string | null;
  // QC worklist summary, annotated server-side (see AssessmentAdminPanelListAPIView).
  qcReviewStatus: QcReviewStatus;
  qcFirstPassDone: boolean;
  qcRound: number | null;
  qcIssuesTotal: number;
  qcIssuesApproved: number;
  qcScore: number | null;
  qcScoreEmailed: number | null;
  qcPointsDeducted: number | null;
  qcPointsTotal: number | null;
  qcStatusAt: string | null;
}

// Derived server-side from the QC lifecycle — never set by hand, so it can't go stale.
export type QcReviewStatus = 'initial_review' | 'pending_assessor' | 'tpn_review' | 'qc_approved';

export const QC_REVIEW_STATUS_LABELS: Record<QcReviewStatus, string> = {
  initial_review: 'Initial Review',
  pending_assessor: 'Pending Assessor',
  tpn_review: 'TPN Review',
  qc_approved: 'QC Reviewed',
};
